import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { FilterListComponent } from 'gung-list';
import { Product } from '../../models';
import { ProductListByIdsConfigService } from '../../services/product-list-by-ids-config/product-list-by-ids-config.service';
import { ProductService } from '../../services/products/product.service';

@Component({
    selector: 'lib-product-list-by-ids',
    template: '<lib-filter-list #productList [configService]="configService"></lib-filter-list>',
    styleUrls: ['./product-list-by-ids.component.css'],
    standalone: false
})
export class ProductListByIdsComponent implements OnInit {
  public configServiceByInjection = inject(ProductListByIdsConfigService);
  protected productService = inject(ProductService);

  @ViewChild('productList') productList: FilterListComponent<Product>;

  @Input() configService: ProductListByIdsConfigService;

  @Input()
  private _productIds: string[];

  @Input() set productIds(value: string[] | string) {
    if (value && !Array.isArray(value)) {
      value = value.split(',');
    }
    if (this.isArrayIdenticalToProductIds(value)) {
      return;
    }
    this._productIds = value as string[];
    this._productIds = this._productIds.map(id => id.trim());
    this.configService?.setSubscriptionIds(this._productIds);
  }

  @Input() set productIdsCSS(values: string) {
    let idsArray = [];
    if (values) {
      idsArray = values.split(',');
    }
    if (this.isArrayIdenticalToProductIds(idsArray)) {
      return;
    }
    this._productIds = idsArray;
    this.configService?.setSubscriptionIds(this._productIds);
  }

  isArrayIdenticalToProductIds(idsArray): boolean {
    if (!!this.ignoreIdenticalArrayCheck) {
      return false;
    }

    if (
      this._productIds &&
      idsArray &&
      this._productIds.length === idsArray.length &&
      this._productIds.every((ele, index) => ele === idsArray[index])
    ) {
      return true;
    }
    return false;
  }

  @Input()
  parentClass: string = 'col-12'; // Use to calculate number item per row

  @Input() ignoreIdenticalArrayCheck: boolean = false;

  ngOnInit() {
    if (!this.configService) {
      this.configService = this.configServiceByInjection;
    }
    this.configService.parentClass = this.parentClass;
    this.configService.setSubscriptionIds(this._productIds);
  }
}
